export const categoryTypes = {
  withCarBrand: 1,
  withoutCarBrand: 2
};
